
export default function ResultsSection() {
  const results = [
    {
      number: '500+',
      title: 'EC事業者支援実績',
      subtitle: '(ECモール最適化)',
      period: null,
    },
    {
      number: '+8,200人',
      title: 'SNSフォロワー数',
      subtitle: '(SNS最適化)',
      period: '3カ月で達成',
    },
    {
      number: '50%',
      title: '顧客獲得単価削減',
      subtitle: '(広告運用改善)',
      period: '半年で達成',
    },
    {
      number: '-70%',
      title: '運用工数削減',
      subtitle: '(AI活用によるDX)',
      period: null,
    },
  ];

  return (
    <section className="py-16 sm:py-24 md:py-32 lg:py-36 bg-[#fafafa]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-10 sm:mb-14 md:mb-18">
          <h2 className="text-lg sm:text-xl md:text-2xl text-[#333333] tracking-wider">実績</h2>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 md:gap-5 lg:gap-6">
          {results.map((result, index) => (
            <div
              key={index}
              className="bg-white border border-gray-100 p-3 sm:p-4 md:p-6 text-center space-y-1.5 sm:space-y-2 shadow-[0_2px_8px_rgba(0,0,0,0.03)]"
            >
              <div className="text-[1rem] sm:text-xl md:text-2xl lg:text-3xl text-[#6b8e6b] font-light tracking-wide whitespace-nowrap">{result.number}</div>
              <p className="text-[0.65rem] sm:text-xs md:text-sm text-[#333333] font-light tracking-wide leading-relaxed">{result.title}</p>
              <p className="text-[0.6rem] sm:text-[0.65rem] md:text-xs text-[#888888] font-light">{result.subtitle}</p>
              {result.period && (
                <p className="text-[0.55rem] sm:text-[0.6rem] md:text-[0.65rem] text-[#6b8e6b]/80 font-light tracking-wide pt-0.5">
                  {result.period}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
